import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM389.4 397.4C351.6 435.2 301.4 456 248 456S144.4 435.2 106.6 397.4 48 309.4 48 256 68.8 152.4 106.6 114.6 194.6 56 248 56 351.6 76.8 389.4 114.6 448 202.6 448 256 427.2 359.6 389.4 397.4zM343.6 196L377.2 155.7C385.8 145.4 373.4 130.9 361.8 137.7L281.8 185.7C274 190.4 274 201.6 281.8 206.3L361.8 254.3C373.3 261.1 385.8 246.7 377.2 236.3L343.6 196zM134.2 254.3L214.2 206.3C222 201.6 222 190.4 214.2 185.7L134.2 137.7C122.6 130.8 110.2 145.4 118.8 155.7L152.4 196 118.8 236.3C110.1 246.7 122.6 261.1 134.2 254.3zM362.4 288H133.6C125.4 288 119.1 295 120.1 303 127.6 362.2 179 408 241.2 408H254.8C317 408 368.4 362.2 375.9 303 376.9 295 370.6 288 362.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh-squint.js
// module id = S5ii
// module chunks = 144